<template>
  <div class="effectComparison">
    <module-container
      title="A/B测试"
      :padding="false"
      :description="'对不同群体的推送效果进行对比'"
    >
    </module-container>
    <div class="page-content">
      <div class="comparison-content">
        <!-- 规则A区域 -->
        <div class="rule-section">
          <div class="rule-section-header">
            <span class="rule-title">规则A</span>
          </div>
          <advanced-search-component
            ref="searchCompA"
            title="规则A"
            :history-id="historyId"
            :open-rate-filter="openRateFilterA"
            @open-rate-change="handleOpenRateChangeA"
            @search-success="handleSearchSuccessA"
            @search-error="handleSearchError"
            @reset="handleResetA"
          />
          <div class="open-rate-filter" v-if="openRateEnabledA">
            <span class="filter-label">打开率：</span>
            <span class="filter-operator">≥</span>
            <el-input
              v-model="openRateFilterA"
              type="number"
              min="0"
              max="100"
              class="filter-input"
              placeholder="请输入"
            />
            <span class="filter-unit">%</span>
          </div>
          <div class="push-count">
            <span class="count-label">推送人数：</span>
            <span class="count-value">{{ pushCountA }}</span>
          </div>
        </div>

        <!-- 规则B区域 -->
        <div class="rule-section">
          <div class="rule-section-header">
            <span class="rule-title">规则B</span>
          </div>
          <advanced-search-component
            ref="searchCompB"
            title="规则B"
            :history-id="historyId"
            :open-rate-filter="openRateFilterB"
            @open-rate-change="handleOpenRateChangeB"
            @search-success="handleSearchSuccessB"
            @search-error="handleSearchError"
            @reset="handleResetB"
          />
          <div class="open-rate-filter" v-if="openRateEnabledB">
            <span class="filter-label">打开率：</span>
            <span class="filter-operator">≥</span>
            <el-input
              v-model="openRateFilterB"
              type="number"
              min="0"
              max="100"
              class="filter-input"
              placeholder="请输入"
            />
            <span class="filter-unit">%</span>
          </div>
          <div class="push-count">
            <span class="count-label">推送人数：</span>
            <span class="count-value">{{ pushCountB }}</span>
          </div>
        </div>

        <!-- 开始对比按钮 -->
        <div class="button-wrapper">
          <el-button
            type="primary"
            :loading="comparing"
            @click="startComparison"
          >
            开始对比
          </el-button>
        </div>
      </div>

      <!-- 检索结果列表 -->
      <div class="result-list" v-if="showChart">
        <div class="result-list-header">
          <h3>对比结果</h3>
        </div>
        <div class="chart-wrapper">
          <bar-chart
            :chart-data="chartData"
            height="450px"
            :y-axis-config="yAxisConfig"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ModuleContainer from '@comp/moduleContainer'
import BarChart from '@/components/charts/BarChart'
import AdvancedSearchComponent from './components/AdvancedSearchComponent.vue'
import { Post, ProjectConfig } from '@/api'
const increment = ProjectConfig.increment

export default {
  name: 'EffectComparison',
  components: {
    ModuleContainer,
    BarChart,
    AdvancedSearchComponent
  },
  data() {
    return {
      historyId: '',
      comparing: false,
      // 打开率筛选值
      openRateFilterA: '',
      openRateFilterB: '',
      // 是否显示打开率筛选（选中"打开率"行为时显示）
      openRateEnabledA: false,
      openRateEnabledB: false,
      // 推送人数
      pushCountA: 0,
      pushCountB: 0,
      // 打开人数
      openCountA: 0,
      openCountB: 0,
      // 打开率
      openRateA: 0,
      openRateB: 0,
      // 规则条件数据
      ruleAConditions: null,
      ruleBConditions: null,
      // 是否显示图表
      showChart: false,
      // 图表数据
      chartData: {
        xAxis: ['规则A', '规则B'],
        series: [
          {
            name: '打开率',
            data: [
              {
                value: 0,
                label: {
                  show: true,
                  position: 'top',
                  color: '#333',
                  formatter: '{c}%'
                },
                tooltip: { formatter: '打开率: {c}%' }
              },
              {
                value: 0,
                label: {
                  show: true,
                  position: 'top',
                  color: '#333',
                  formatter: '{c}%'
                },
                tooltip: { formatter: '打开率: {c}%' }
              }
            ]
          }
        ]
      },
      // Y轴配置
      yAxisConfig: {
        name: '打开率（%）',
        min: 0,
        max: 100,
        nameLocation: 'middle',
        nameGap: 55,
        nameRotate: 90,
        nameTextStyle: {
          color: '#333',
          fontSize: 14
        },
        axisLabel: {
          formatter: '{value}%'
        }
      }
    }
  },
  computed: {
    analysisPath() {
      return `/newActivePushAnalysis?columnId=${this.$route.query.columnId}&type=${this.$route.query.type}&taskId=${this.$route.query.taskId}`
    },
    breadcrumbPath() {
      return `/newActivePushEmail?columnId=${this.$route.query.columnId}&type=${this.$route.query.type}`
    }
  },
  created() {
    this.historyId = this.$route.query.taskId || ''
  },
  methods: {
    handleSearchSuccessA(res, params) {
      this.ruleAConditions = params
      if (res && res.data) {
        this.pushCountA = res.data.data || 0
      }
    },
    handleSearchSuccessB(res, params) {
      this.ruleBConditions = params
      if (res && res.data) {
        this.pushCountB = res.data.data || 0
      }
    },
    handleSearchError(err) {
      console.error('检索错误：', err)
    },
    handleOpenRateChangeA(enabled) {
      this.openRateEnabledA = enabled
      if (!enabled) {
        this.openRateFilterA = ''
      }
    },
    handleOpenRateChangeB(enabled) {
      this.openRateEnabledB = enabled
      if (!enabled) {
        this.openRateFilterB = ''
      }
    },
    handleResetA() {
      this.pushCountA = 0
      this.openCountA = 0
      this.openRateA = 0
      this.openRateFilterA = ''
      this.openRateEnabledA = false
      this.ruleAConditions = null
      this.showChart = false
    },
    handleResetB() {
      this.pushCountB = 0
      this.openCountB = 0
      this.openRateB = 0
      this.openRateFilterB = ''
      this.openRateEnabledB = false
      this.ruleBConditions = null
      this.showChart = false
    },
    async startComparison() {
      this.comparing = true

      const params = {
        historyId: Number(this.historyId) || this.historyId,
        groupA: this.$refs.searchCompA.buildSearchParams().group,
        groupB: this.$refs.searchCompB.buildSearchParams().group
      }

      try {
        const res = await Post(increment.GetABTestCompare.url, params)
        if (res.data.status === 0 && res.data.data && res.data.data.groups) {
          const groups = res.data.data.groups
          const groupA = groups.find((g) => g.name === '规则A') || groups[0]
          const groupB = groups.find((g) => g.name === '规则B') || groups[1]

          if (groupA) {
            this.openCountA = groupA.openCount || 0
            this.openRateA = groupA.openRateValue || 0
          }
          if (groupB) {
            this.openCountB = groupB.openCount || 0
            this.openRateB = groupB.openRateValue || 0
          }

          this.chartData = {
            xAxis: ['规则A', '规则B'],
            series: [
              {
                name: '打开率',
                data: [
                  {
                    value: this.openRateA,
                    label: {
                      show: true,
                      position: 'top',
                      color: '#333',
                      formatter: '{c}%'
                    },
                    tooltip: { formatter: `打开率: ${this.openRateA}%` }
                  },
                  {
                    value: this.openRateB,
                    label: {
                      show: true,
                      position: 'top',
                      color: '#333',
                      formatter: '{c}%'
                    },
                    tooltip: { formatter: `打开率: ${this.openRateB}%` }
                  }
                ]
              }
            ]
          }
          this.showChart = true
        } else {
          this.$message.error(res.data.message || '对比失败')
        }
      } catch (err) {
        console.error('对比错误：', err)
        this.$message.error('对比失败，请重试')
      } finally {
        this.comparing = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.effectComparison {
  background: #f5f7fd;
  min-height: 100vh;

  .page-content {
    margin: 20px 0;
    background: #fff;
  }

  .comparison-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
    padding: 24px;
  }

  .rule-section {
    background: #fafbfc;
    border-radius: 8px;
    padding: 16px;
    min-width: 420px;
    flex: 1;

    .rule-section-header {
      margin-bottom: 12px;

      .rule-title {
        font-size: 16px;
        font-weight: 600;
        color: #333;
      }
    }
  }

  .open-rate-filter {
    display: flex;
    align-items: center;
    margin-top: 12px;

    .filter-label {
      font-size: 14px;
      color: #333;
      width: 80px;
      font-weight: bolder;
    }

    .filter-operator {
      font-size: 14px;
      color: #333;
      margin-right: 4px;
    }

    .filter-input {
      width: 100px;
    }

    .filter-unit {
      font-size: 14px;
      color: #606266;
      margin-left: 4px;
    }
  }

  .push-count {
    display: flex;
    align-items: center;
    margin-top: 12px;
  }

  .count-label {
    font-size: 14px;
    color: #333;
    width: 80px;
    font-weight: bolder;
  }

  .count-value {
    font-weight: 600;
  }

  .button-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 16px 0;
  }

  .button-wrapper .el-button {
    width: 160px;
    height: 40px;
    font-size: 14px;
  }

  .result-list {
    margin-top: 24px;
    padding: 24px;
    background: #fff;
    border-top: 1px solid #ebeef5;

    .result-list-header {
      margin-bottom: 16px;

      h3 {
        margin: 0;
        font-size: 16px;
        font-weight: 600;
        color: #303133;
      }
    }
  }

  .chart-wrapper {
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
  }
}

@media (max-width: 768px) {
  .effectComparison .comparison-content {
    flex-direction: column;
  }

  .effectComparison .rule-section {
    min-width: 100%;
    max-width: 100%;
  }
}
</style>
